export default class addSubscribersToEvent {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/event/directives/add-subscribers-to-event.html'),
            controller: AddSubscribersCtrl,
            controllerAs: 'modal'
        }
    }
}

class AddSubscribersCtrl {
    constructor($scope, $filter, Event, Events, SweetAlert) {
        this._scope = $scope;
        this._translator = $filter('translate');

        this.eventRepo = Event;
        this.eventHandler = Events;
        this.alerter = SweetAlert;

        this.visible = false;
        this.to = { tags: [], segments: [], subscribers: [] };

        this._scope.$on('event:inviteMore:show', (event, data) => {
            this.event = data.event;
            this.visible = true;
        });
    }

    close() {
        this.visible = false;
    };

    noSelection() {
        return ! (this.to.tags.length || this.to.segments.length || this.to.subscribers.length);
    };

    invite() {
        this.alerter.swal({
            title: this._translator('EVENT:ADD_SUBSCRIBERS:INVITE_HEADER'),
            text: this._translator('EVENT:ADD_SUBSCRIBERS:INVITE_BODY'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO')
        }, (isConfirm) => {
            if (isConfirm) {
                this.eventRepo.addInvitations(this.event.id, this.to).then(() => {
                    this.visible = false;

                    this.eventHandler.flashEvent('notification', this._translator('EVENT:ADD_SUBSCRIBERS:ADDED'));
                    this._scope.$emit('event:update');
                });
            }
        });
    };
};
